import { useState } from 'react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import BeneficiariesFollowup from 'features/Onboarding/components/BeneficiariesFollowup';
import Header from 'features/Onboarding/components/Header';

import OBNavigation from '../../../../components/OBNavigation/OBNavigation';
import { GetBeneficiariesDataQuery } from '../../graphql/queries/getBeneficiariesData.gql';
import locales from './locales';

export type FollowupProps = {
  legalBeneficiaries: GetBeneficiariesDataQuery['viewer']['company']['legalBeneficiaries'];
  userProfile: GetBeneficiariesDataQuery['viewer']['profile'];
};

const Followup = asBentoPage<FollowupProps>(
  ({ Layout, legalBeneficiaries, onPrev, userProfile }) => {
    const [isAddingNewBeneficiary, setIsAddingNewBeneficiary] = useState(false);

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        {isAddingNewBeneficiary ? null : <Header title={locales.title} />}
        <BeneficiariesFollowup
          accountHolderEmail={userProfile.email ?? ''}
          beneficiaries={legalBeneficiaries}
          isAddingNewBeneficiary={isAddingNewBeneficiary}
          onAddBeneficiaryClicked={() => setIsAddingNewBeneficiary(true)}
          onAddBeneficiaryDone={() => setIsAddingNewBeneficiary(false)}
        />
      </Layout>
    );
  },
);

export default Followup;
